module.exports = __webpack_public_path__ + "img/gather_sleeve_opening.2193b366.png";